<cam-input-checkbox [input]="this.input" [standalone]="true" (valueChanged)="this.toggle($event)"></cam-input-checkbox>
